import { render } from "./VSpacer.vue?vue&type=template&id=7b26f858&scoped=true"
import script from "./VSpacer.vue?vue&type=script&lang=js"
export * from "./VSpacer.vue?vue&type=script&lang=js"

import "./VSpacer.vue?vue&type=style&index=0&id=7b26f858&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b26f858"]])

export default __exports__